"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * A grid is a container that consists of a group of cells. Grid can define its own max-width or designate its columns to be a certain width. Cells get positioned in sequence according to a predefined number of columns.
 *
 * The grid has 12 columns in desktop mode (>= 840px), 8 columns in tablet mode (>= 480px), and 4 columns in phone mode (< 480px). Cells specify how many columns to span (the default is 4). Cells are placed side by side until there is no more room, then the next cell is placed at the beginning of the next row.
 */


var LayoutGrid = function (_Component) {
  _inherits(LayoutGrid, _Component);

  function LayoutGrid() {
    _classCallCheck(this, LayoutGrid);

    return _possibleConstructorReturn(this, (LayoutGrid.__proto__ || Object.getPrototypeOf(LayoutGrid)).apply(this, arguments));
  }

  _createClass(LayoutGrid, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _props = this.props,
          nested = _props.nested,
          align = _props.align,
          fixedColumnWidth = _props.fixedColumnWidth,
          className = _props.className,
          children = _props.children,
          other = _objectWithoutProperties(_props, ["nested", "align", "fixedColumnWidth", "className", "children"]);

      if (nested) {
        return _react2.default.createElement("div", {
          className: (0, _classnames3.default)("mdc-layout-grid__inner", className)
        }, children);
      }

      return _react2.default.createElement("div", _extends({
        className: (0, _classnames3.default)("mdc-layout-grid", (_classnames = {}, _defineProperty(_classnames, "mdc-layout-grid--align-" + align, align), _defineProperty(_classnames, "mdc-layout-grid--fixed-column-width", fixedColumnWidth), _classnames), className)
      }, other), _react2.default.createElement("div", {
        className: "mdc-layout-grid__inner"
      }, children));
    }
  }]);

  return LayoutGrid;
}(_react.Component);

LayoutGrid.propTypes = {
  /** The nested layout grid behaves exactly like when they are not nested, but margins are not re-introduced since they are living within another cell. */
  nested: _propTypes.bool,

  /** The grid is by default center aligned. User can add `left` or `right` modifier prop to change this behavior. Note, these modifiers will have no effect when the grid already fills its container. */
  align: (0, _propTypes.oneOf)(["left", "right"]),

  /** Defines the container by width designated column width (set by --mdc-layout-grid-column-width-* variables). */
  fixedColumnWidth: _propTypes.bool
};
exports.default = LayoutGrid;